import React, { useState } from 'react';
import {
  Container,
  Typography,
  Paper,
  TextField,
  Button,
  Box,
  Link,
  Grid,
  Checkbox,
  FormControlLabel,
  Divider,
  Alert
} from '@mui/material';
import {
  AccountCircle as AccountCircleIcon,
  Email as EmailIcon,
  Lock as LockIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Image
} from '@mui/icons-material';
import { Link as RouterLink, useHistory } from 'react-router-dom';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [avatar, setAvatar] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreement, setAgreement] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const history = useHistory();

  const handleRegister = async (event) => {
    event.preventDefault();
    console.log('注册按钮点击事件');
    
    if (password !== confirmPassword) {
      setError('密码和确认密码不一致');
      return;
    }
    
    if (!agreement) {
      setError('请同意用户协议和隐私政策');
      return;
    }
    
    setLoading(true);
    setError('');
    setSuccess('');
    
    try {
      const response = await fetch('/api/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          password,
          avatar
        }),
      });

      const data = await response.json();

      if (data.success) {
        setSuccess('注册成功！即将跳转到登录页面...');
        setLoading(false); // 添加这行代码
        setTimeout(() => {
          history.push('/login');
        }, 2000);
      } else {
        setError(data.message || '注册失败');
        setLoading(false);
      }
    } catch (error) {
      console.error('注册失败:', error);
      setError('网络错误，请稍后重试');
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper sx={{ mt: 8, p: 4 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <AccountCircleIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
          <Typography component="h1" variant="h5">
            注册
          </Typography>
        </Box>

        <Box component="form" onSubmit={handleRegister} sx={{ mt: 1 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="邮箱地址"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputProps={{
              startAdornment: <EmailIcon sx={{ mr: 1, color: 'text.secondary' }} />,
            }}
          />

          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="密码"
            type={showPassword ? 'text' : 'password'}
            id="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              startAdornment: <LockIcon sx={{ mr: 1, color: 'text.secondary' }} />,
              endAdornment: (
                <Button
                  onClick={() => setShowPassword(!showPassword)}
                  sx={{ minWidth: 0 }}
                >
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </Button>
              ),
            }}
          />

          <TextField
            margin="normal"
            required
            fullWidth
            name="confirmPassword"
            label="确认密码"
            type={showConfirmPassword ? 'text' : 'password'}
            id="confirmPassword"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            InputProps={{
              startAdornment: <LockIcon sx={{ mr: 1, color: 'text.secondary' }} />,
              endAdornment: (
                <Button
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  sx={{ minWidth: 0 }}
                >
                  {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </Button>
              ),
            }}
          />

          <TextField
            margin="normal"
            fullWidth
            id="avatar"
            label="头像链接（可选）"
            name="avatar"
            value={avatar}
            onChange={(e) => setAvatar(e.target.value)}
            InputProps={{
              startAdornment: <Image sx={{ mr: 1, color: 'text.secondary' }} />,
            }}
          />

          <FormControlLabel
            control={
              <Checkbox
                value="agreement"
                color="primary"
                checked={agreement}
                onChange={(e) => setAgreement(e.target.checked)}
              />
            }
            label={
              <Typography variant="body2">
                我同意
                <Link href="#" variant="body2">
                  用戶协议
                </Link>
                和
                <Link href="#" variant="body2">
                  隐私政策
                </Link>
              </Typography>
            }
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
            id="register-button"
          >
            {loading ? '注册中...' : '注册'}
          </Button>

          <Grid container>
            <Grid item xs>
              <Link component={RouterLink} to="/login" variant="body2">
                已有账户？立即登录
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  );
};

export default Register;
